import { Star, CheckCircle2 } from "lucide-react";
import { useState } from "react";
import { X } from "lucide-react";
import { useCounts, useParticipation } from "../lib/participation";
import { ShareMenu } from "./ShareMenu";

const Toggle = ({ on, onClick, icon: Icon, label, count, title, testId }) => (
  <button onClick={onClick} aria-pressed={on} title={title} data-testid={testId}
    className={`part-toggle inline-flex flex-1 items-center justify-center gap-1.5 rounded-full border px-3 py-2 text-sm font-semibold transition-colors ${on ? "border-emerald-600 bg-emerald-600 text-white" : "border-slate-300 bg-white text-slate-800 hover:border-emerald-600"}`}>
    <Icon size={15} />{label}<span className={`rounded-full px-1.5 text-xs ${on ? "bg-white/25" : "bg-slate-100 text-slate-700"}`} data-testid={`${testId}-count`}>{count ?? "–"}</span>
  </button>
);

export const ParticipationButtons = ({ o, showSupporters = false, context }) => {
  const c = useCounts(o.id);
  const { mine, toggle } = useParticipation();
  const m = mine[o.id] || {};
  const [prompt, setPrompt] = useState(false);
  const tap = (kind) => { if (!m[kind]) setPrompt(true); toggle(o, kind, context); };
  return (
    <div data-testid={`participation-${o.id}`}>
      <div className="flex gap-2">
        <Toggle on={!!m.interested} onClick={() => tap("interested")} icon={Star} label="Interested" count={c?.interested}
          title="I'm interested in this opportunity" testId={`interested-btn-${o.id}`} />
        <Toggle on={!!m.attended} onClick={() => tap("attended")} icon={CheckCircle2} label="Attended" count={c?.attended}
          title="I took part, attended, volunteered, donated or plan to" testId={`attended-btn-${o.id}`} />
      </div>
      {prompt && (m.interested || m.attended) && (
        <div className="mt-2 flex items-center gap-2 rounded-2xl bg-emerald-50 px-3 py-2 text-sm text-emerald-900" data-testid={`going-prompt-${o.id}`}>
          <span className="flex-1 font-medium">Be the Change — tell friends you're going</span>
          <ShareMenu path={`/volunteer/${o.id}`} title={o.title} kind="going" testId={`going-share-${o.id}`} />
          <button onClick={() => setPrompt(false)} aria-label="Dismiss" data-testid={`going-dismiss-${o.id}`} className="rounded-full p-1 hover:bg-emerald-100"><X size={14} /></button>
        </div>
      )}
      {showSupporters && <p className="mt-2 text-xs text-slate-600" data-testid={`supporters-${o.id}`}>{c?.supporters ?? 0} supporter{c?.supporters === 1 ? "" : "s"} on RippleImpact</p>}
    </div>
  );
};
